import { Hidden } from '@material-ui/core';
/*import WarningIcon from '@material-ui/icons/Warning';*/
import React from 'react';
import { buttonStyles } from '../../../../global/constants/theme/styles/components/buttonstyles';
import { ListItem } from '../../../../search/search-model';
import { SearchProps } from '../../models/arc-epi-props';
import { InstitutionItem } from '../institutions/institution-model';



interface InstitutionItemProps {
    item: ListItem,
    action: () => void,
    settings: SearchProps,
}


export const InstitutionItemView = (props: InstitutionItemProps) => {

    const casted = props.item as InstitutionItem;
    const buttonClasses = buttonStyles();
    return (
        <div className='sort-table-row'>
            <div className='sort-table-row-cell'>
                <Hidden smUp>
                    <p className='input-label'>{props.settings?.institutionIdLabel}</p>
                </Hidden>
                <p>
                    <button className={buttonClasses.linkButton} type='button' onClick={props.action}>
                        {casted?.client_number}
                    </button>

                </p>
            </div>
            <div className='sort-table-row-cell'>
                <Hidden smUp>
                    <p className='input-label'>{props.settings?.institutionNameLabel}</p>
                </Hidden>
                <p>
                    {casted?.legal_name}
                </p>
            </div>

            <div className='sort-table-row-cell'>
                <Hidden smUp>
                    <p className='input-label'>{props.settings?.institutionCityLabel}</p>
                </Hidden>
                <p>
                    {casted?.mailing_address?.city}
                </p>
            </div>            
        </div>);
};